var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3276 25.8473L28.7449 23.812C27.3862 22.0667 26.6382 19.886 26.6382 17.674V17.3333V11.3333C26.6382 5.084 21.5542 0 15.3049 0C9.05558 0 3.97158 5.084 3.97158 11.3333V17.3333V17.674C3.97158 19.886 3.22358 22.0667 1.86491 23.8127L0.282244 25.8487C-0.0330894 26.2533 -0.0884227 26.792 0.137577 27.2527C0.362244 27.7133 0.821577 28 1.33424 28H10.6916C11.0169 30.2573 12.9589 32 15.3049 32C17.6509 32 19.5929 30.2573 19.9182 28H29.2749C29.7882 28 30.2469 27.7133 30.4722 27.2527C30.6982 26.792 30.6429 26.2533 30.3276 25.8473ZM15.3049 30.6667C13.6956 30.6667 12.3489 29.5193 12.0389 28H18.5709C18.2609 29.5193 16.9142 30.6667 15.3049 30.6667ZM1.33491 26.6667L2.91758 24.6313C4.45691 22.652 5.30491 20.1807 5.30491 17.674V17.3333V11.3333C5.30491 5.81933 9.79091 1.33333 15.3049 1.33333C20.8189 1.33333 25.3049 5.81933 25.3049 11.3333V17.3333V17.674C25.3049 20.1813 26.1529 22.652 27.6922 24.632L29.2756 26.6667H1.33491Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_icon.bc053dbcf9bc85f9f58f52b006cac168.svg";
export { ForwardRef as ReactComponent };